import { createAction, props } from '@ngrx/store';

import { UmParticipantResponse } from '../../../models/um-participant-response';
import { UmParticipant } from '../../../models/um-participant';

export const getUmParticipants = createAction(
  '[User Management Participant] Get Participants',
  props<{ pageNumber?: number; pageSize?: number; filterValue?: string }>()
);

export const getUmParticipantsSuccess = createAction(
  '[User Management Participant] Get Participants Success',
  props<{ umParticipantResponse: UmParticipantResponse }>()
);

export const getUmParticipantsError = createAction('[User Management Participants] Get Participants Error');

export const selectUmParticipant = createAction(
  '[User Management Participant] Set Selected Participant',
  props<{ participantId: number }>()
);

export const selectUmParticipantSuccess = createAction(
  '[User Management Participant] Set Selected Participant Success',
  props<{ selectedUmParticipant: UmParticipant }>()
);

export const selectUmParticipantError = createAction('[User Management Participant] Set Selected Participant Error');

export const deleteParticipantFromSystemAndKeepData = createAction(
  '[User Management Participant] Remove Participant From System And Keep Data',
  props<{ participantId: number }>()
);

export const deleteParticipantFromSystemAndKeepDataSuccess = createAction(
  '[User Management Participant] Remove Participant From System And Keep Data Success'
);

export const deleteParticipantFromSystemAndKeepDataError = createAction(
  '[User Management Participant] Remove Participant From System And Keep Data Error'
);

export const deleteParticipantFromSystemAndRemoveData = createAction(
  '[User Management Participant] Remove Participant From System And Remove Data',
  props<{ participantId: number }>()
);

export const deleteParticipantFromSystemAndRemoveDataSuccess = createAction(
  '[User Management Participant] Remove Participant From System And Remove Data Success'
);

export const deleteParticipantFromSystemAndRemoveDataError = createAction(
  '[User Management Participant] Remove Participant From System And Remove Data Error'
);

export const withdrawParticipantFromStudyAndKeepData = createAction(
  '[User Management Participant] Withdraw Participant From Study And Keep Data',
  props<{ studyId: number; participantId: number }>()
);

export const withdrawParticipantFromStudyAndKeepDataSuccess = createAction(
  '[User Management Participant] Withdraw Participant From Study And Keep Data Success',
  props<{ umParticipant: UmParticipant }>()
);

export const withdrawParticipantFromStudyAndRemoveData = createAction(
  '[User Management Participant] Withdraw Participant From Study And Remove Data',
  props<{ studyId: number; participantId: number }>()
);

export const withdrawParticipantFromStudyAndRemoveDataSuccess = createAction(
  '[User Management Participant] Withdraw Participant From Study And Remove Data Success',
  props<{ umParticipant: UmParticipant }>()
);

export const withdrawParticipantFromStudyAndRemoveDataError = createAction(
  '[User Management Participant] Withdraw Participant From Study And Remove Data Error'
);

export const withdrawParticipantFromStudyAndKeepDataError = createAction(
  '[User Management Participant] Withdraw Participant From Study And Keep Data Error'
);

export const withdrawParticipantFromStudyAndKeepDataAnonymous = createAction(
  '[User Management Participant] Withdraw Participant From Study And Keep Data Anonymous',
  props<{ studyId: number; participantId: number }>()
);

export const withdrawParticipantFromStudyAndKeepDataAnonymousSuccess = createAction(
  '[User Management Participant] Withdraw Participant From Study And Keep Data Anonymous Success',
  props<{ umParticipant: UmParticipant }>()
);

export const withdrawParticipantFromStudyAndKeepDataAnonymousError = createAction(
  '[User Management Participant] Withdraw Participant From Study And Keep Data Anonymous Error'
);

export const downloadParticipantHistory = createAction(
  '[User Management Participant] Download Participant History',
  props<{ participantId: number }>()
);

export const downloadParticipantHistorySuccess = createAction(
  '[User Management Participant] Download Participant History Success'
);

export const downloadParticipantHistoryError = createAction(
  '[User Management Participant] Download Participant History Error'
);

export const downloadStudyAnswers = createAction(
  '[User Management Participant] Download Participant Study Answers',
  props<{ participantId: number; studyId: number; studyType: string }>()
);

export const downloadStudyAnswersSuccess = createAction(
  '[User Management Participant] Download Participant Study Answers Success'
);

export const downloadStudyAnswersError = createAction(
  '[User Management Participant] Download Participant Study Answers Error'
);

export const downloadParticipantData = createAction(
  '[User Management Participant] Download Participant Data',
  props<{ participantId: number }>()
);

export const downloadParticipantDataSuccess = createAction(
  '[User Management Participant] Download Participant Data Success'
);

export const downloadParticipantDataError = createAction(
  '[User Management Participant] Download Participant Data Error'
);
